import { createApp } from 'vue';
import { i18n } from './lang';
import router from '@/routes';
import 'bootstrap/dist/js/bootstrap.bundle';

import App from './App.vue';
import './assets/scss/application.scss';
import { createPinia } from 'pinia';

const pinia = createPinia()

export const app = createApp(App)
    .use(i18n)
    .use(pinia)
    .use(router)
    .mount('#app')


declare global {
    interface Window {
        APP_CONFIG: ApplicationConfig;
    }
}

/**
 * app config loaded externally
 */
interface ApplicationConfig {
    legal: Record<string, Record<string, string>>,
    forgerock: {
        amBase: string, // base AM URL
        timeout?: number,
        logLevel?: 'none' | 'info' | 'warn' | 'error' | 'debug',
    }
    feat: Record<string, Record<string, any>>,
}
